import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

export class WAccionesPerfilTipoEstadoItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: WAccionesPerfilTipoEstadoViewModel[];
}

export class WAccionesPerfilTipoEstadoViewModel {
    public Id: number;
    public IdModulo: number | null = null;
    public Modulo: string;
    public IdAccion: number | null = null;
    public Accion = '';
    public IdPerfil: number | null = null;
    public Perfil: string;
    public IdEstado: number | null = null;
    public EstadoSolicitud: string;
    public IdTipo: number | null = null;
    public TipoSolicitud: string;
    public IdSubtipo: number | null = null;
    public SubTipoSolicitud: string;
    public Edicion = false;
}

export class FilterSearchingWAccionesPerfilTipoEstadoViewModel extends FilterSearchingBaseViewModel {
    public IdModulo: number | null = null;
    public IdAccion: number | null = null;
    public Accion = '';
    public IdPerfil: number | null = null;
    public IdEstado: number | null = null;
    public IdTipo: number | null = null;
    public IdSubtipo: number | null = null;
    public Edicion: number = EnumSiNoTodos.TODOS;
}

export class TwTcAccionesViewModel {
    public Id: number;
    public IdModulo: number;
    public Descripcion: string;
    public Codigo: string;
    public Estado: boolean;
    public Tipo: boolean;
    public Subtipo: boolean;
}
